import { Grid } from "@mui/material";

import FormOne from "./FormOne";
import FormTwo from "./FormTwo";

export default function FormDisplay({
  agencyID,
  multiBrand,
  list,
  editState,
  formikProps,
  setEditState,
}) {
  return (
    <Grid container spacing={4} style={{ padding: "20px" }}>
      <FormOne
        setEditState={setEditState}
        list={list}
        agencyID={agencyID}
        multiBrand={multiBrand}
        formikProps={formikProps}
        editState={editState}
      />

      <FormTwo
        agencyID={agencyID}
        list={list}
        multiBrand={multiBrand}
        formikProps={formikProps}
        editState={editState}
      />
    </Grid>
  );
}
